<div class="flag" [attr.data-viewport]="viewport">
  <span class="flag-label" [innerHTML]="label"></span>
</div>
